const _toBinary = (content) => {
    const codeUnits = new Uint16Array(content.length);
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = content.charCodeAt(i);
    }
    const charCodes = new Uint8Array(codeUnits.buffer);
    let result = '';
    for (let i = 0; i < charCodes.byteLength; i++) {
        result += String.fromCharCode(charCodes[i]);
    }
    return result;
};
const _fromBinary = (binary) => {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    const charCodes = new Uint16Array(bytes.buffer);
    let result = '';
    for (let i = 0; i < charCodes.length; i++) {
        result += String.fromCharCode(charCodes[i]);
    }
    return result;
};
/**
 * Encode string as base64
 */
export const encodeString = (content) => {
    try {
        return window.btoa(_toBinary(content));
    }
    catch (_a) {
        // ancient browsers -> do not encode
        return content;
    }
};
/**
 * Decode string from base64
 */
export const decodeString = (content) => {
    try {
        return _fromBinary(window.atob(content));
    }
    catch (_a) {
        // ancient browsers -> do not encode
        return content;
    }
};
